import logo from './logo.svg';
import './App.css';
import Nevbar from './Components/Nevbar/Nevbar';
import Footer from './Components/Footer/Footer';
import Home from './Components/Home/Home';
import About from './Components/About/About';
import Services from './Components/Services/Services';
import Whyus from './Components/Whyus/Whyus';
import Process from './Components/Process/Process';
import Contact from './Components/Contact/Contact';
import Back from './Components/Back/Back';
import Whatsapp from './Components/Whatsapp/Whatsapp';

function App() {
  return (
    <div className="App">
     <Nevbar/>
     <Home/>
     <About/>
     <Services/>
     <Whyus/>
     <Process/>
     <Contact/>
     <Back/>
     <Whatsapp/>
     <Footer/>
     
    </div>
  );
}

export default App;
